import { Injectable } from "@angular/core";
import { SafeUrl } from "@angular/platform-browser";
import { BehaviorSubject, ReplaySubject } from "rxjs";
import { AppConstants } from "../../constants/constants";
import { User } from "../user.types";


@Injectable({
    providedIn: 'root'

})
export class UserState {

    private static userState: BehaviorSubject<User> = new BehaviorSubject<User>(null);
    private static userPhotoState: BehaviorSubject<SafeUrl> = new BehaviorSubject<SafeUrl>(null);

    static getUserState(): BehaviorSubject<User> { return this.userState; }
    static getUserPhotoState(): BehaviorSubject<SafeUrl> { return this.userPhotoState; }

    static setUserState(user: User): void {
        localStorage.setItem(AppConstants.PRISISTED_KEYS.CURRENT_USER, JSON.stringify(user));
        let pessmision: string[] = [];

        // user.permissions.forEach((permissionGroup: any) => {
        //     permissionGroup.permissions.forEach((singlePermission: any) => {
        //         if (singlePermission.enabled) {
        //             pessmision.push(singlePermission.value)
        //         }
        //     })
        // });
        // localStorage.setItem(AppConstants.PRISISTED_KEYS.USER_PERMISSIONS, JSON.stringify(pessmision));
        this.userState.next(user);
    }
    static setUserPhotoState(value: SafeUrl): void { this.userPhotoState.next(value); }

}

